import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentSection } from "@cinch-labs/design-system";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import styles from "./instructions-table.module.css";
export var InstructionsTable = function(param) {
    var instructions = param.instructions;
    return /*#__PURE__*/ _jsx(ContentSection, {
        children: /*#__PURE__*/ _jsx("table", {
            className: styles.table,
            children: /*#__PURE__*/ _jsx("tbody", {
                children: instructions.map(function(step) {
                    return /*#__PURE__*/ _jsxs("tr", {
                        children: [
                            /*#__PURE__*/ _jsx("td", {
                                children: /*#__PURE__*/ _jsx("p", {
                                    children: step.browser
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                children: renderWithResolver(step.steps)
                            })
                        ]
                    }, step._uid);
                })
            })
        })
    });
};
